module.exports = __webpack_public_path__ + "static/media/asia.c10c9fd3.jpeg";